module.exports = "/fonts/fa-brands-400.svg?0cb5a5c0d251c109458c85c6afeffbaa";